export default {"src":"/_next/static/media/edg.e7dfec0f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};